<template>
  <div>
    <!-- 充值记录弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="充值记录"
      :visible.sync="rechargeDialogVisible"
      :before-close="rechargeHandleClose"
      width="53%"
      center
    >
      <el-divider></el-divider>
      <el-table
        :data="rechargeTableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <!-- 空数据状态的插槽 -->
        <template slot="empty" class="emptyImg">
          <img style="width:264px;height:207px" :src="imgUrl" alt srcset />
          <div class="fsws">暂无数据</div>
          <!-- <el-empty :image-size="100" description="暂无数据"></el-empty> -->
        </template>
        <el-table-column label="编号" type="index"></el-table-column>
        <!-- <el-table-column prop="name" label="收费类别"></el-table-column>
        <el-table-column prop="address" label="计费类型"></el-table-column>-->
        <el-table-column prop="Pay" label="充值数量"></el-table-column>
        <el-table-column prop="Balance" label="充后余额"></el-table-column>
        <el-table-column prop="UserID" label="操作人"></el-table-column>
        <el-table-column prop="PayTime" label="充值时间"></el-table-column>
        <!-- <el-table-column prop="address" label="金飞鹰收款金额"></el-table-column>
        <el-table-column prop="address" label="收款时间"></el-table-column>
        <el-table-column prop="address" label="备注">
          <template slot-scope="scope">
            <el-button class="remark" type="text" @click="remarkFn()">备注内容</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination" v-if="total">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="rechargePar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{rechargePar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="rechargePar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 充值记录弹框开始 -->
  </div>
</template>

<script>
import { distrbutorRechargeRecordPost } from "@/request/fxs.js";
export default {
  data() {
    return {
      imgUrl: require("@/images/fxs/zwsj.png"),
      rechargeDialogVisible: false,
      // 充值记录传参
      rechargePar: {
        distrbutor_id: "",
        page: 1,
        page_size: 8,
        token: ""
      },
      total: 0,
      rechargeTableData: []
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
  },
  methods: {
    // 备注内容
    remarkFn() {},
    // 充值弹框
    recharge(row) {
      // console.log(row);
      this.rechargePar = {
        distrbutor_id: row.DistributorID,
        page: 1,
        page_size: 8,
        token: this.Token
      };
      console.log(this.rechargePar);
      this.getData(this.rechargePar);
      this.rechargeDialogVisible = true;
    },
    // 调取接口
    getData(data) {
      distrbutorRechargeRecordPost(data).then(res => {
        console.log(res);
        this.rechargeTableData = res.data.result.data;
      });
    },
    // 充值弹框X
    rechargeHandleClose() {
      this.rechargeDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.rechargePar.page = val;
      this.getData(this.rechargePar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
/* 去掉table 最底部的线 */
/deep/ .el-table--border::after,
/deep/ .el-table--group::after,
/deep/ .el-table::before {
  background-color: transparent;
}
.el-table__empty-text {
  img {
    margin-top: 136px;
    margin-bottom: 73px;
  }
}
.remark {
  color: black;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 20px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

</style>